'use strict';

/*global MapMarkerAbstract */
/*global SMap */

function MapMarkerSMap(options) {
   MapMarkerAbstract.call(this, options);

    this.marker = new SMap.Marker(SMap.Coords.fromWGS84(options.position.lng, options.position.lat), options.id, {});
    this.layer = null;
}

MapMarkerSMap.prototype = $.extend({}, MapMarkerAbstract.prototype, {
    construtor: 'MapMarkerSMap',

    setMap: function setMap(map) {
        var _this = this;

        _this.layer = new SMap.Layer.Marker();
        map.addLayer(_this.layer);
        _this.layer.enable();
        _this.layer.addMarker(_this.marker);

        return _this;
    },

    setVisible: function setVisible(visible) {
        var _this = this;

        if (_this.layer) {
            _this.layer.enable();
        }

        return _this;
    }
});
